import {createAction as createReduxAction} from 'web-app/util/redux/typed-action-helpers';
import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {
    CANCELING_LEAVE_ACTION_TYPE,
    CANCELING_LEAVE_ACTION_TYPE_SUCCESS,
    CONFIRM_ACTION_TYPE,
    CONFIRM_LEAVE_ACTION_TYPE,
    CONFIRM_LEAVE_ACTION_TYPE_SUCCESS,
    FILTER_GROUP_ACTION_TYPE,
    SHOW_UPCOMING_CHILDREN,
} from './action-types';

export const {
    action: confirming,
    success: confirmingSuccess,
    failed: confirmingFailed,
} = createAction(CONFIRM_ACTION_TYPE, (loadingChild, loadingDate) => ({loadingChild, loadingDate}));

export const {action: filterByBroup} = createAction(FILTER_GROUP_ACTION_TYPE, groupToFilter => ({groupToFilter}));

export const {action: confirmLeave} = createReduxAction(
    CONFIRM_LEAVE_ACTION_TYPE,
    (payload: {childId: string; startDate: string; endDate: string}) => {
        return payload;
    },
);

export const {action: confirmLeaveSuccess} = createReduxAction(
    CONFIRM_LEAVE_ACTION_TYPE_SUCCESS,
    (payload: {childId: string; endDate: string}) => payload,
);

export const {action: cancelLeave} = createReduxAction(
    CANCELING_LEAVE_ACTION_TYPE,
    (payload: {childId: string; startDate: string}) => {
        return payload;
    },
);

export const {action: cancelLeaveSuccess} = createReduxAction(
    CANCELING_LEAVE_ACTION_TYPE_SUCCESS,
    (payload: {childId: string}) => payload,
);

// dont delete - references dont work, but its used.
export const {action: showUpComingChildren} = createReduxAction(SHOW_UPCOMING_CHILDREN, (payload: any) => {
    return payload;
});
